export const mainPageLayoutLink = 'https://ortus-dev.artyshok.com.ua/';
export const analysesAtHomePageLayoutLink =
  'https://ortus-dev.artyshok.com.ua/nurse';
export const covidPageLayoutLink = 'https://ortus-dev.artyshok.com.ua/covid';
export const aboutPageLayoutLink = 'https://ortus-dev.artyshok.com.ua/about';
